var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { CACHE_TIME, STALE_TIME } from "../ApiProvider";
import { api } from "./api";
import { USE_RETRIEVE_DIVISION, USE_RETRIEVE_DIVISIONS_BY_SEASON_ID, } from "./DivisionApiProvider";
var USE_RETRIEVE_SEASONS_BY_LEAGUE_ID = "useRetrieveSeasonsByLeagueId";
var USE_RETRIEVE_SEASON = "useRetrieveSeason";
export var useRetrieveSeasonsByLeagueId = function (_a) {
    var leagueId = _a.leagueId, _b = _a.enabled, enabled = _b === void 0 ? true : _b;
    return useQuery({
        queryKey: [USE_RETRIEVE_SEASONS_BY_LEAGUE_ID, leagueId],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/leagues/".concat(leagueId, "/seasons/"))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); },
        enabled: !!leagueId && enabled,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export var useRetrieveSeason = function (_a) {
    var id = _a.id, _b = _a.enabled, enabled = _b === void 0 ? true : _b;
    return useQuery({
        queryKey: [USE_RETRIEVE_SEASON, id],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/seasons/".concat(id, "/"))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); },
        enabled: !!id && enabled,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export var useCreateSeason = function (_a) {
    var onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (data) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, api.post("/seasons/", data)];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function (data) {
            var leagueId = data.data
                .league;
            queryClient.invalidateQueries([
                USE_RETRIEVE_SEASONS_BY_LEAGUE_ID,
                leagueId,
            ]);
            onSuccess(data);
        },
        onError: onError,
    });
};
export var useUpdateSeason = function (_a) {
    var onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (data) { return __awaiter(void 0, void 0, void 0, function () {
            var id;
            return __generator(this, function (_a) {
                id = data.id;
                return [2 /*return*/, api.put("/seasons/".concat(id, "/"), data)];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function (data) {
            var season = data.data;
            var leagueId = season.league;
            queryClient.invalidateQueries([
                USE_RETRIEVE_SEASONS_BY_LEAGUE_ID,
                leagueId,
            ]);
            queryClient.invalidateQueries([USE_RETRIEVE_SEASON, season.id]);
            if (onSuccess)
                onSuccess(data);
        },
        onError: onError,
    });
};
export var useDeleteSeason = function (_a) {
    var onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
            var id = _b.id, leagueId = _b.leagueId;
            return __generator(this, function (_c) {
                return [2 /*return*/, api.delete("/seasons/".concat(id, "/")).then(function () { return ({ id: id, leagueId: leagueId }); })];
            });
        }); },
        onMutate: function (vars) { return onMutate && onMutate(vars.id); },
        onSuccess: function (_res, vars) {
            queryClient.invalidateQueries([
                USE_RETRIEVE_SEASONS_BY_LEAGUE_ID,
                vars.leagueId,
            ]);
            queryClient.removeQueries([USE_RETRIEVE_SEASON, vars.id]);
            if (onSuccess)
                onSuccess();
        },
        onError: onError,
    });
};
export var useCancelSeason = function () {
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
            var id = _b.id;
            return __generator(this, function (_c) {
                return [2 /*return*/, api.post("/seasons/".concat(id, "/cancel/"))];
            });
        }); },
        onSuccess: function (data) {
            var season = data.data;
            var leagueId = season.league;
            queryClient.invalidateQueries([USE_RETRIEVE_SEASON, season.id]);
            queryClient.invalidateQueries([
                USE_RETRIEVE_SEASONS_BY_LEAGUE_ID,
                leagueId,
            ]);
        },
    });
};
export var useAssignTeamsToDivisions = function (_a) {
    var seasonId = _a.seasonId, onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (data) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, api.patch("/seasons/".concat(seasonId, "/assign-teams/"), data)];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function (data) {
            // Invalidate season data to refresh divisions and their teams
            queryClient.invalidateQueries([USE_RETRIEVE_SEASON, seasonId]);
            // Also invalidate any division-specific queries if they exist
            queryClient.invalidateQueries([USE_RETRIEVE_DIVISION]);
            queryClient.invalidateQueries([
                USE_RETRIEVE_DIVISIONS_BY_SEASON_ID,
                seasonId,
            ]);
            if (onSuccess)
                onSuccess(data);
        },
        onError: onError,
    });
};
// Season Config hooks
var USE_RETRIEVE_SEASON_CONFIG = "useRetrieveSeasonConfig";
var USE_RETRIEVE_SEASON_MATCHES = "useRetrieveSeasonMatches";
var USE_RETRIEVE_LEAGUE_MATCH = "useRetrieveLeagueMatch";
export var useRetrieveSeasonMatches = function (_a) {
    var seasonId = _a.seasonId, divisionId = _a.divisionId, _b = _a.enabled, enabled = _b === void 0 ? true : _b;
    return useQuery({
        queryKey: [USE_RETRIEVE_SEASON_MATCHES, seasonId, divisionId],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var params, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = divisionId ? "?division=".concat(divisionId) : "";
                        return [4 /*yield*/, api.get("/seasons/".concat(seasonId, "/matches/").concat(params))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); },
        enabled: !!seasonId && enabled,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export var useRetrieveSeasonConfig = function (_a) {
    var seasonId = _a.seasonId, _b = _a.enabled, enabled = _b === void 0 ? true : _b;
    return useQuery({
        queryKey: [USE_RETRIEVE_SEASON_CONFIG, seasonId],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/seasons/".concat(seasonId, "/config/"))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); },
        enabled: !!seasonId && enabled,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export var useUpdateSeasonConfig = function (_a) {
    var seasonId = _a.seasonId, onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (data) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, api.patch("/seasons/".concat(seasonId, "/config/"), data)];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function (data) {
            queryClient.invalidateQueries([USE_RETRIEVE_SEASON_CONFIG, seasonId]);
            if (onSuccess)
                onSuccess(data);
        },
        onError: onError,
    });
};
export var useGenerateFixtures = function (_a) {
    var seasonId = _a.seasonId, onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, api.post("/seasons/".concat(seasonId, "/generate/"))];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function (data) {
            // Invalidate season and config to reflect updated status
            queryClient.invalidateQueries([USE_RETRIEVE_SEASON, seasonId]);
            queryClient.invalidateQueries([USE_RETRIEVE_SEASON_CONFIG, seasonId]);
            // Also invalidate the seasons list (status changed to active)
            queryClient.invalidateQueries([USE_RETRIEVE_SEASONS_BY_LEAGUE_ID]);
            if (onSuccess)
                onSuccess(data);
        },
        onError: onError,
    });
};
export var useRetrieveLeagueMatch = function (_a) {
    var id = _a.id, _b = _a.enabled, enabled = _b === void 0 ? true : _b;
    return useQuery({
        queryKey: [USE_RETRIEVE_LEAGUE_MATCH, id],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/league-matches/".concat(id, "/"))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); },
        enabled: !!id && enabled,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export var useCreateLeagueMatch = function (_a) {
    var onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (data) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, api.post("/league-matches/", data)];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function (data) {
            queryClient.invalidateQueries([USE_RETRIEVE_SEASON_MATCHES]);
            if (onSuccess)
                onSuccess(data);
        },
        onError: onError,
    });
};
export var useUpdateLeagueMatch = function (_a) {
    var onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (data) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, api.put("/league-matches/".concat(data.id, "/"), data)];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function (data) {
            var match = data.data;
            queryClient.invalidateQueries([USE_RETRIEVE_LEAGUE_MATCH, match.id]);
            queryClient.invalidateQueries([USE_RETRIEVE_SEASON_MATCHES]);
            if (onSuccess)
                onSuccess(data);
        },
        onError: onError,
    });
};
export var useDeleteLeagueMatch = function (_a) {
    var onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (id) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, api.delete("/league-matches/".concat(id, "/"))];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function () {
            queryClient.invalidateQueries([USE_RETRIEVE_SEASON_MATCHES]);
            if (onSuccess)
                onSuccess();
        },
        onError: onError,
    });
};
export var useCreateLeagueMatchResult = function (leagueMatch, onMutate, onSuccess, onError) {
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (data) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, api.post("/league-match-results/", data)];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function () {
            queryClient.invalidateQueries([
                USE_RETRIEVE_LEAGUE_MATCH,
                leagueMatch === null || leagueMatch === void 0 ? void 0 : leagueMatch.id,
            ]);
            queryClient.invalidateQueries([USE_RETRIEVE_SEASON_MATCHES]);
            onSuccess();
        },
        onError: onError,
    });
};
export var useUpdateLeagueMatchResult = function (leagueMatch, onMutate, onSuccess, onError) {
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (data) { return __awaiter(void 0, void 0, void 0, function () {
            var id;
            var _a;
            return __generator(this, function (_b) {
                id = (_a = leagueMatch === null || leagueMatch === void 0 ? void 0 : leagueMatch.leagueMatchResult) === null || _a === void 0 ? void 0 : _a.id;
                return [2 /*return*/, api.put("/league-match-results/".concat(id, "/"), data)];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function () {
            queryClient.invalidateQueries([
                USE_RETRIEVE_LEAGUE_MATCH,
                leagueMatch === null || leagueMatch === void 0 ? void 0 : leagueMatch.id,
            ]);
            queryClient.invalidateQueries([USE_RETRIEVE_SEASON_MATCHES]);
            onSuccess();
        },
        onError: onError,
    });
};
export var useBulkUpdatePlayerLeagueMatchStats = function (leagueMatch, onMutate, onSuccess, onError) {
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (data) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, api.put("/bulk/player-league-match-stats/update/", { updates: data })];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function () {
            queryClient.invalidateQueries([
                USE_RETRIEVE_LEAGUE_MATCH,
                leagueMatch === null || leagueMatch === void 0 ? void 0 : leagueMatch.id,
            ]);
            queryClient.invalidateQueries([USE_RETRIEVE_SEASON_MATCHES]);
            onSuccess();
        },
        onError: onError,
    });
};
